import React, { useState } from 'react';
//import './navbar.css';
import { Link } from "react-router-dom"
import { OverlayTrigger, Popover, Row, Col} from 'react-bootstrap';
import Presenze_tooltip from "./Progetto_x2_presenze_tooltip.jsx";



const Visualizza_presenze_per_alunno = (props) => {
//    const [somma, calcola_somma] = useState('');
    function disegna_iconcina_presenza(valore_presenza, mezza_giornata) {
        //        console.log('disegna_iconcina_presenza');
        //        console.log(mezza_giornata);

        if (valore_presenza === -1 && mezza_giornata) {
            return <div>
                ?
                </div>
        }
        if (valore_presenza === 1 && mezza_giornata) {
            return <div>
                &#9989;
                </div>
        }
        if (valore_presenza === 0 && mezza_giornata) {
            return <div>
                &#10060;
                </div>
        }
        if (!mezza_giornata) {
            return <div>
                -
                </div>
        }
    }

    function calcola_ore_minuti(minuti) {
        //  console.log('aaaaaaaaaaaaaaaaaaaaaaa')
        //  console.log(newDate)
          
        //  console.log('YYYYYYYYYYYYYYYYYYYYYYYYYYYYY  NON DATA ')
          
        let giorni = 0
        let ore = 0
        let minuti_rimanenti = minuti 
       
        if (minuti_rimanenti > 24*60) {
             giorni = minuti_rimanenti / (24*60)
            
             giorni = Math.floor(giorni) 
    
             minuti_rimanenti = minuti_rimanenti - (giorni * 24 * 60)
        }
        if (minuti_rimanenti > 60) {
            ore = minuti_rimanenti / (60)
            ore = Math.floor(ore) 
            minuti_rimanenti = minuti_rimanenti - (ore * 60)
       }
       
        minuti_rimanenti = Math.floor(minuti_rimanenti) 
           
        let formatted = ` ${ore}h ${minuti_rimanenti}m `
        if (giorni > 0) {formatted = ` ${giorni}d, ${ore}h ${minuti_rimanenti}m`}
    
        return formatted.toString()
    }

    function calcola_minuti_di_risposta_mail(tempo_risposta, tempo_inviomail, mezza_giornata) {
        //        console.log('calcola_minuti_di_risposta_mail');

        //        console.log(tempo_risposta + '  ' + tempo_inviomail);
        var data1 = new Date(tempo_risposta);


        var data2 = new Date(tempo_inviomail);
        var minuti = (data1.getTime() - data2.getTime()) / (1000 * 60);

        const popover_variabile = (
        
            <Popover id="popover-basic">
              <Popover.Header as="h3">Popover right</Popover.Header>
              <Popover.Body>
                    <Presenze_tooltip   tempo_inviomail={tempo_inviomail}
                                        tempo_risposta={tempo_risposta} 
                                        data2={data2.getTime()} 
                                        minuti={minuti}/> 
              </Popover.Body>
            </Popover>
         
        )
        if (mezza_giornata && minuti > 0) {
            return <>
            <OverlayTrigger trigger="hover" placement="right" overlay={popover_variabile}>
                    <div>
                        {calcola_ore_minuti(minuti)}
                    </div>
            </OverlayTrigger>
            </>
        }
        if (mezza_giornata && minuti < 0) {
            return <>
             -
            </>
        }
        if (!mezza_giornata) {
            return <div>
                -
            </div>
        }
    }


    return (
    <> 
        <div>
            <Row>
                {/* 
                <h4> Alunno: {props.progetto.id_alunno.cognome}  -  {props.progetto.id_alunno.nome}

                     

                   {props.progetto.alunno_collegato != undefined && <>
                   
                    {props.progetto.alunno_collegato[0].cognome}  -  {props.progetto.alunno_collegato[0].nome}
                    </>}
                </h4>
                */}
            </Row>
            <Row>
                <Col>

                </Col>
                <Col>
                    Mattina
            </Col>
                <Col>
                    Pomeriggio
            </Col>
            </Row>

            <Row>
                <Col>
                    Giorno
            </Col>
                <Col>
                    Feed ditta1
            </Col>
                <Col>
                    Feed alunno1
            </Col>
                <Col>
                    Feed ditta2
            </Col>
                <Col>
                    Feed alunno2
            </Col>
            </Row>
            <hr class="rounded"></hr>
        </div>
        {/* www.idroslab.com */}
        {props.progetto.presenze.slice(0).reverse().map(function (item, index2) {
            {
                //                            console.log('XXXadesso')
                var dateObj = new Date(item.data_mattina);
                var month = dateObj.getUTCMonth() + 1; //months from 1-12
                var day = dateObj.getUTCDate();

                var newdate = day + "/" + month;
                //                                    console.log(item)
                const weekday = ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"];
                let giorno = weekday[dateObj.getDay()];


                return <div>
                    <Row>
                        <Col>
                            {props.progetto.presenze.length - index2 - 1} - {newdate}  {giorno}
                        </Col>
                        <Col>
                            {disegna_iconcina_presenza(item.ditta1, props.progetto.mattina)}
                            {calcola_minuti_di_risposta_mail(item.ditta1_data, item.data_mattina, props.progetto.mattina)}

                        </Col>
                        <Col>
                            {disegna_iconcina_presenza(item.alunno1, props.progetto.mattina)}
                            {calcola_minuti_di_risposta_mail(item.alunno1_data, item.data_mattina, props.progetto.mattina)}

                        </Col>

                        <Col>
                            {disegna_iconcina_presenza(item.ditta2, props.progetto.pomeriggio)}
                            {calcola_minuti_di_risposta_mail(item.ditta2_data, item.data_pomeriggio, props.progetto.pomeriggio)}
                        </Col>
                        <Col>
                            {disegna_iconcina_presenza(item.alunno2, props.progetto.pomeriggio)}
                            {calcola_minuti_di_risposta_mail(item.alunno2_data, item.data_pomeriggio, props.progetto.pomeriggio)}

                        </Col>
                    </Row>
                    <hr class="rounded"></hr>
                </div>
            }
        })}

    </>
    )
}
export default Visualizza_presenze_per_alunno;